import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=50fab1bc&scoped=true&"
import script from "./Scanner.vue?vue&type=script&lang=ts&"
export * from "./Scanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fab1bc",
  null
  
)

export default component.exports